import { Component, Input } from '@angular/core';

// Modal hosting the vehicle renewal component.
@Component({
  selector: 'expired-cars-modal',
  templateUrl: './expired-cars-modal.component.html',
})
export class ExpiredCarsModalComponent {
  @Input() isOpen: boolean = false;
}
